import classes from './Table.module.css';
import { useState, useEffect } from 'react';

function PageNext(props) {
      
    const [Styles, setStyles] = useState("default");

    let button_style = `${classes.page_next}`; //"nav_button default";


    useEffect(() => {
        if ( props.active )
        {
            setStyles("default");
        }
    }, [props.active]);


    function handleMouseEnter()
    {
        setStyles("hover");
    }
    function handleMouseLeave()
    {
        setStyles("default");
    }

    if ( Styles==="default" )
    {
        button_style = `${classes.page_next}`; //"nav_button default";
    }
    if ( Styles==="hover" )
    {
        button_style = `${classes.page_next} ${classes.hover}`; //"nav_button hover";
    }
    if ( !props.active )
    {
        button_style = `${classes.page_next} ${classes.inactive}`; //"nav_button inactive";
    }

    return(
        <div style={{postion: 'relative', width:'20px', height:'20px'}}>
            {props.active ? (
                 <button className={button_style} onClick={props.handleClick} onMouseLeave={handleMouseLeave} onMouseEnter={handleMouseEnter}></button>
            ) : (
                <button className={button_style} ></button>
            )}
        </div>
    );


}


export default PageNext;